import { apiGet, apiPost } from "./client.js";
import type {
  DocumentRunSummary,
  DocumentCandidateSummary,
  DocumentFinding,
} from "./product-types.js";

export async function getLatestDocuments(
  websiteId: string,
): Promise<DocumentRunSummary | null> {
  return apiGet<DocumentRunSummary | null>(`/websites/${websiteId}/documents`);
}

export async function getDocumentCandidates(
  websiteId: string,
  runId: string,
): Promise<DocumentCandidateSummary[]> {
  return apiGet<DocumentCandidateSummary[]>(
    `/websites/${websiteId}/documents/${runId}/candidates`,
  );
}

export async function getDocumentFindings(
  websiteId: string,
  runId: string,
): Promise<DocumentFinding[]> {
  return apiGet<DocumentFinding[]>(
    `/websites/${websiteId}/documents/${runId}/findings`,
  );
}

export async function triggerDocumentScan(
  websiteId: string,
): Promise<DocumentRunSummary> {
  return apiPost<DocumentRunSummary>(`/websites/${websiteId}/documents`, {});
}
